import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dcc-footer-items-dropdown',
  templateUrl: './footer-items-dropdown.component.html',
  styleUrls: ['./footer-items-dropdown.component.scss'],
})
export class FooterItemsDropdownComponent {
  @Output() changedPageSize = new EventEmitter<number>();

  @Input() pageSize = 50;
  pageSizes: number[] = [50, 100, 150, 200];

  onPageSizeSelected(pageSize: number): void {
    this.changedPageSize.emit(pageSize);
  }
}
